import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { EligiblityForTeacherPopupComponent } from '../eligiblity-for-teacher-popup/eligiblity-for-teacher-popup.component';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-eligiblity-for-teacher',
  templateUrl: './eligiblity-for-teacher.component.html',
  styleUrls: ['./eligiblity-for-teacher.component.scss']
})
export class EligiblityForTeacherComponent implements OnInit {
  teacherEligibility: FormGroup;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  eligibilityList: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
      private modalPopupService: ModalpopService,
      private dialog: MatDialog,
      private fb: FormBuilder,
      public router: Router,
      private spinner:NgxSpinnerService, ) { }

  ngOnInit(): void {
        this.getTeacherEligibility();
        this.teacherEligibility = this.fb.group({
          SearchString: new FormControl('')
        })
        window.scroll(0, 0);
  }

 onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getTeacherEligibility();
    // this.keypress()
  }
  
  getTeacherEligibility() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.searchTeacherEligibility(payload).subscribe(res => {
      this.spinner.hide();
      this.eligibilityList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      // this.sortedData = [...this.courseList];
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.eligibilityList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
  addnewrecord() {
      const dialogRef = this.dialog.open(EligiblityForTeacherPopupComponent, {
        width: '120vh',
        data: {key : "New"},
        disableClose: true  
      });
      dialogRef.afterClosed().subscribe(result => {
            this.getTeacherEligibility();
            this.teacherEligibility.controls['SearchString'].setValue('');
       
      });
    }

    editData(k){
      console.log('k',k)
        const dialogRef = this.dialog.open(EligiblityForTeacherPopupComponent, {
          width: '120vh',
          data: { selected: k, key : "Edit"},
          disableClose: true 
        });
        dialogRef.afterClosed().subscribe(result => {
            this.getTeacherEligibility();
            this.teacherEligibility.controls['SearchString'].setValue('');
        });
      }
    
      deleteData(k){
        const dialogRef = this.dialog.open(EligiblityForTeacherPopupComponent, {
          width: '120vh',
          data: { selected: k, key : "Delete"},
          disableClose: true 
        });
        dialogRef.afterClosed().subscribe(result => {
            this.getTeacherEligibility();
            this.teacherEligibility.controls['SearchString'].setValue('');
        });
      }
    
      keypress() {
        if(this.setIntervalSearch){
          clearTimeout(this.setIntervalSearch);
        }
        this.setIntervalSearch = setTimeout(()=>{
          this.eligibilityList = [];
        const payload = {};
        payload['PageSize'] = this.pageSize;
        payload['SearchString'] = this.teacherEligibility.value['SearchString'];
        if (payload['SearchString'] === "") {
          payload['PageNumber'] = this.currentPage;
        } else {
          payload['PageNumber'] = 1;
        }
        this.umsService.searchTeacherEligibility(payload).subscribe(
          (res) => {
            if(res.status){
              this.eligibilityList = res.data;
              this.totalItems = res.data[0].TotalRecords;
            }
            else{
              this.eligibilityList = [];
            this.totalItems = 0
            }
           
            }, (ERROR: HttpErrorResponse) => {
            this.eligibilityList = [];
            this.totalItems = 0
          });
        },1000)
       
     
      }
}
